import { t } from "@lingui/macro";
import { I18n } from "@lingui/core";

import { FieldName } from "..";

export default (i18n: I18n) => ({
  iban: {
    name: FieldName.iban,
    label: "IBAN",
    placeholder: `${i18n._(
      t({
        id: "placeholder.example",
        message: "e.g.",
      })
    )} FI21 1234 5600 0007 85`,
    instructions: i18n._(
      t({
        id: "fields-config.iban.instructions",
        message: "International Bank Account Number",
      })
    ),
  },
  local: [
    {
      name: FieldName.bankCode,
      label: "Code Banque",
      placeholder: `${i18n._(
        t({
          id: "placeholder.example",
          message: "e.g.",
        })
      )} 500015`,
      instructions: i18n._(
        t({
          id: "fields-config.bank-code.instructions",
          message: "Bank code",
        })
      ),
    },
    {
      name: FieldName.accountNumber,
      label: "Tilinumeron rakenne",
      placeholder: `${i18n._(
        t({ id: "placeholder.example", message: "e.g." })
      )} 456`,
      instructions: i18n._(
        t({
          id: "fields-config.account-number.instructions",
          message: "Account number",
        })
      ),
    },
  ],
  primaryBankDetailsFields: [FieldName.iban],
  secondaryBankDetailsField: [FieldName.bankCode, FieldName.accountNumber],
});
